// extracted by mini-css-extract-plugin
export var next = "PostNav-module--next--tJHi7";
export var prev = "PostNav-module--prev--9SOUx";
export var root = "PostNav-module--root--y6Uq6";